import axiosInstanceQueries from '../queriesAxios';
import { useMutation } from '@tanstack/react-query';
import store from 'store/store';
import app from 'store/app/app';
import { ApiInviteMembers } from './types';
import { fetchActiveUserOrganization } from 'store/myAccount/requests';
import { USER_AUDIT_TRAIL } from '@verify/shared-utils';
import { trackEvent } from 'components/Tracker/TrackerProvider';

const inviteMember = async (email: string, roleId: string, hasAuditTrail?: boolean): Promise<ApiInviteMembers> => {
  return axiosInstanceQueries
    .post('organizations/invite', { email, roleId, hasAuditTrail })
    .then((response) => response.data);
};

interface InviteMembersMutationParams {
  email: string;
  roleId: string;
  hasAuditTrail?: boolean;
  orgId?: string;
  isBulk?: boolean;
  roleName?: string;
}
export const useInviteMembersMutation = () => {
  return useMutation({
    mutationFn: ({ email, roleId, hasAuditTrail }: InviteMembersMutationParams) =>
      inviteMember(email, roleId, hasAuditTrail),
    onSuccess: (data: ApiInviteMembers, params: InviteMembersMutationParams) => {
      const { email, hasAuditTrail, orgId, isBulk, roleName } = params;
      if (data.successfulInvites > 0) {
        trackEvent({
          name: 'user-invited',
          data: {
            ...(!isBulk && { userEmail: email }),
            tenantId: orgId,
            isBulk: !!isBulk,
            successfulInvites: data.successfulInvites,
            failedInvites: data.failedInvites.length,
            role: roleName,
            additionalRoles: hasAuditTrail ? [USER_AUDIT_TRAIL] : [],
          },
        });
      }

      if (!isBulk) {
        if (data.failedInvites.length === 0) {
          if (orgId) {
            store.dispatch(fetchActiveUserOrganization(orgId, true, true));
          }
          store.dispatch(
            app.actions.setSnackMessage({
              message: `Your invitation was just sent!`,
              type: 'success',
            }),
          );
        } else {
          store.dispatch(
            app.actions.setSnackMessage({
              message: data.failedInvites[0]?.error ?? 'There was an error sending the invitation. Please try again',
              type: 'error',
            }),
          );
        }
      }
      return data;
    },
    onError: (_err) => {
      store.dispatch(
        app.actions.setSnackMessage({
          message: 'There was an error sending the invitation. Please try again',
          type: 'error',
        }),
      );
    },
  });
};
